import {filter, isArray} from "lodash"

import {getDemoTenant} from "./"


/**
 * Filters a list of cycles by demo
 *
 * @param cycles
 * @returns {array}
 */
export default (cycles, cycleUuid) => {
  if (!isArray(cycles)) return cycles

  const {cycleId: id} = getDemoTenant()
  return filter(cycles, {id: cycleUuid || id})
}
